export default __webpack_public_path__ + "static/media/Spectral Cape.c6ea50e4.jpg";